// extracted by mini-css-extract-plugin
module.exports = {"container":"redirect_container__sKkyb","bgGlow":"redirect_bgGlow__VFS5F","desktop":"redirect_desktop__ghvfY","mobile":"redirect_mobile__y0StF"};